import React from 'react';

const BtnContext = React.createContext({
	clicked: false
});

export default BtnContext;
